import { useMutation, useQueryClient } from "@tanstack/react-query";
import { salesDb } from "@/integrations/supabase/sales-client";
import { useAuth } from "@/context/auth";
import { toast } from "sonner";

export const useAssignStudent = () => {
  const { user } = useAuth();
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({ eventId, fishsixCode }: { eventId: string; fishsixCode: string }) => {
      if (!user?.email || !user?.id) throw new Error("Not authenticated");

      const { data: bal } = await salesDb()
        .from("v_student_event_balance")
        .select("event_balance")
        .eq("fishsix_student_code", fishsixCode)
        .maybeSingle();
      const balance = Number(bal?.event_balance ?? 0);
      if (balance <= 0) throw new Error("ไม่มีคงเหลือ assign ไม่ได้");

      const nowIso = new Date().toISOString();
      const { data: cb, error: cbErr } = await salesDb()
        .from("student_cashbacks")
        .insert({
          fishsix_student_code: fishsixCode,
          hours: 1,
          action: "deduct",
          cashback_type: "event",
          status: "approved",
          created_by: user.email,
          approved_by: user.email,
          approved_at: nowIso,
        })
        .select("id")
        .single();
      if (cbErr) throw cbErr;

      const { error: aErr } = await salesDb()
        .from("event_assignments")
        .insert({
          event_id: eventId,
          fishsix_student_code: fishsixCode,
          cashback_id: cb.id,
          assigned_by: user.id,
        });
      if (aErr) throw aErr;
    },
    onSuccess: (_d, vars) => {
      toast.success("เพิ่มนักเรียนและหัก 1 ครั้งเรียบร้อย");
      qc.invalidateQueries({ queryKey: ["event-assignments", vars.eventId] });
      qc.invalidateQueries({ queryKey: ["event-balances"] });
      qc.invalidateQueries({ queryKey: ["student-event-history", vars.fishsixCode] });
      qc.invalidateQueries({ queryKey: ["fishsix-student-search-events"] });
    },
    onError: (e: any) => {
      toast.error(e?.message ?? "Assign นักเรียนไม่สำเร็จ");
    },
  });
};
